import AddBatchUserModal from "./AddBatchUserModal";

export default AddBatchUserModal;
